import React from "react";
import { UserSettings } from "../modules/UserSettings";

export function UserSettingsPage() {
  return <UserSettings />;
}
